<template>
  <div class="right">
    <div class="search-box form-input">
      <el-input class="search-input" v-model="deviceName"  placeholder="请输入"></el-input>
      <div class="buttom-bg buttom-bg2 btn" @click="getDeviceTree">
        搜索
      </div>
    </div>
    <div class="video-menu scroll-y">
      <div class="video-menu-box">
        <div class="menu-list" v-for="item in deviceTree" :key="item.town">
          <div class="list-label">
            <div class="openIcon" @click="item.open = !item.open">+</div>
            <div class="line">-------------</div>
            <div class="label">{{ item.town }}</div>
          </div>
          <div class="menu-child" v-if="item.open">
            <div class="child-list"
                 v-for="device in item.list"
                 :key="device.id"
                 @click="changeDevice(device)"
                 :class="{ active: activeDevice.deviceSerial === device.deviceSerial}">
              <div class="circle" :class="{ red: device.status !== 1 }"></div>
              <div class="child-text">{{ device.deviceName || device.deviceSerial }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getDeviceTree, getLiveAddress} from "../../../../api/device";

export default {
  name: "BottomRight",
  data () {
    return {
      deviceName: '',
      deviceTree: [],
      activeDevice: {
        deviceSerial: ''
      }
    }
  },
  mounted() {
    this.getDeviceTree(true)
    this.$bus.on('editDevice', () => {
      getDeviceTree({ deviceName: this.deviceName}).then(res => {
        res.data.forEach((item, i) => {
          item.open = this.deviceTree[i].open
        })
        this.deviceTree = res.data
      })
    })
  },
  beforeDestroy() {
    this.$bus.off('editDevice')
  },
  methods: {
    getDeviceTree (PlayFirst) {
      getDeviceTree({ deviceName: this.deviceName}).then(res => {
        let playList = []
        res.data.forEach(item => {
          item.open = true
          item.list.forEach(device => {
            if (device.status === 1) {
              playList.push(device)
            }
          })
        })
        if (PlayFirst) {
          if (playList.length === 0) {
            this.$message.warning('暂无在线设备')
          } else {
            this.getDeviceInfo(playList[0])
          }
        }
        this.deviceTree = res.data
      })
    },
    changeDevice(device) {
      if (device.status !== 1) {
        return this.$message.warning('该设备不在线')
      }
      this.getDeviceInfo(device)
    },
    getDeviceInfo (device) {
      getLiveAddress({ deviceSerials: [ device.deviceSerial ] }).then(res => {
        if (device.type === 0) { // 海康
          this.activeDevice = res.data.haiKangYS7[0]
          this.$emit('getDeviceInfo', {
            token: res.data.haiKangYS7Token,
            info: this.activeDevice,
            type: 0
          })
        } else {
          res.data.daHuaYunRui[0].streams = [...res.data.daHuaYunRui[0].streams, ...res.data.daHuaYunRui[1].streams]
          this.activeDevice = {...res.data.daHuaYunRui[0], ...{deviceSerial: device.deviceSerial}}
          this.$emit('getDeviceInfo', {
            token: res.data.daHuaYunRuiToken,
            info: this.activeDevice,
            type: 1
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.right {
  margin-left: 20px;
  //width: 530px;
  background-image: url("../../../../assets/dp/bottom-right.png");
  background-size: 100% 100%;
  padding: 30px 0px 30px 40px;
  height: calc(100% - 60px);
  z-index: 9;
  .search-box{
    display: flex;
    align-items: center;
    .search-input{
      width: 300px;
      height: 40px;
    }
    .btn {
      height: 50px;
      width: 137px;
      text-align: center;
      line-height: 50px;
      cursor: pointer;
    }
    .buttom-bg2 {
      background: url("~@/assets/img/settings/button-bg2.png") no-repeat
        center/ 100% 100%;
      color: #00b2ff;
      font-size: 18px;
      .icon-shuaxin {
        font-size: 18px;
        margin-right: 8px;
      }
    }
  }
  .video-menu{
    margin-top: 30px;
    margin-left: 10px;
    padding-top: 20px;
    padding-left: 20px;
    max-height: calc(100vh - 420px);
    position: relative;
    overflow: auto;
    .video-menu-box{
      height: auto;
      border-left: 1px dashed #00B2FF;
    }
    &::after{
      content: '';
      width: 1px;
      height: 13px;
      display: block;
      position: absolute;
      bottom: 0px;
      left: -1px;
      border-left: 1px solid #000000;
    }
    .menu-list{
      margin-bottom: 20px;
      .list-label{
        position: relative;
        left: -11px;
        top: -11px;
        display: flex;
        align-items: center;
        .openIcon{
          width: 18px;
          height: 18px;
          color: #00B2FF;
          font-size: 18px;
          border: 1px solid #00B2FF;
          background: #005174;
          line-height: 18px;
          text-align: center;
          cursor: pointer;
          position: relative;
          z-index: 66666666;
        }
        .line{
          color: #00B2FF;
        }
        .label{
          font-size: 18px;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 28px;
          text-shadow: 3px 3px 5px #32b0f8;
        }
      }
      .menu-child{
        border-left: 1px dashed #00B2FF;
        margin-left: 75px;
        position: relative;
        &::after{
          content: '';
          width: 1px;
          height: 7px;
          display: block;
          position: absolute;
          bottom: 0px;
          left: -1px;
          border-left: 1px solid #000000;
        }
        .active{
          text-shadow: 3px 3px 5px #00FFEE;
          background-color: rgba(0, 255, 238, 0.05);
          border-right: 4px solid #00FFEE;
        }
        .child-list{
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          font-size: 14px;
          position: relative;
          top: -5px;
          left: -6px;
          cursor: pointer;
          .circle {
            background: #013E52;
            border: 1px solid #00FFEE;
            border-radius: 50%;
            height: 10px;
            width: 10px;
            margin-right: 5px;
          }
          .red{
            background: #37112E;
            border: 1px solid #FF1C2F;
          }
          &:hover{
            text-shadow: 3px 3px 5px #00FFEE;
            background-color: rgba(0, 255, 238, 0.05);
            border-right: 4px solid #00FFEE;
          }
        }
      }
    }
  }
}
</style>
